import { useMultiRecords } from "../../../../../components/hooks";

import {
  FormInputtext,
  FormCalendar,
} from "../../../../../components/formElement";
import { option_isgraduation } from "../../../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModuleProfileCertificates({
  options: { setting, getValues, setValue, trigger, setIsFormUpdate, disabled },
}) {
  const { addDetailBlock, deleteMulti, replayMulti, renderMultiRecordsTb } =
    useMultiRecords({
      blockData: {
        certificates: {
          name: "",
          start_date: "",
          end_date: "",
          certificate_number: "",
          remark: "",
        },
      },
      updateForm: ({ name, data }) => {
        setValue(name, data);
        trigger(name);
        setIsFormUpdate(true);
      },
    });

  return (
    <>
      {renderMultiRecordsTb({
        columnLength: 2,
        data: getValues("certificates") || [],
        columnKey: "certificates",
        headTemplate: (
          <>
            <tr className="bg-tb-subtitle">
              <th>相關證照</th>
              <th className="w-4rem">動作</th>
            </tr>
          </>
        ),
        bodyTemplate: ({ data, rowIndex }) => (
          <>
            <td>
              <div className="formgrid grid">
                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    證照名稱
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `certificates[${rowIndex}].name`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    證照起訖日期
                  </label>
                  <div className="col-12 sm:col-8">
                    <div className="flex align-items-center">
                      <FormCalendar
                        className="w-full"
                        setting={setting}
                        data={{
                          name: `certificates[${rowIndex}].start_date`,
                          showIcon: false,
                          disabled: disabled || data.flag === "delete",
                        }}
                      />
                      <span className="mx-1">-</span>
                      <FormCalendar
                        className="w-full"
                        setting={setting}
                        data={{
                          name: `certificates[${rowIndex}].end_date`,
                          showIcon: false,
                          disabled: disabled || data.flag === "delete",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    證照號碼
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `certificates[${rowIndex}].certificate_number`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>

                <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 md:col-6 my-1">
                  <label
                    htmlFor="type"
                    className="col-12 sm:col-4 text-left sm:text-right mb-1 sm:mb-0"
                  >
                    備註
                  </label>
                  <div className="col-12 sm:col-8">
                    <FormInputtext
                      setting={setting}
                      data={{
                        name: `certificates[${rowIndex}].remark`,
                        disabled: disabled || data.flag === "delete",
                      }}
                    />
                  </div>
                </div>
              </div>
            </td>
          </>
        ),
      })}
    </>
  );
}
